import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@material-ui/core";
import * as React from "react";
import { useNotify } from "react-admin";

export default function RequestRejectedRemark(props) {
  const [open, setOpen] = React.useState(false);
  const [remark, setRemark] = React.useState("");
  const notify = useNotify();

  React.useEffect(() => {
    setOpen(props?.open ?? false);
  }, [props.open]);
  const handleClickSubmit = () => {
    if (!remark) {
      notify(`Remark can not be null!`, "warning", false, false);
    } else {
      props.handleSubmit(props.record, remark);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Remark</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            onChange={e => {
              if (e?.target?.value?.length < 2000) {
                setRemark(e?.target?.value ?? "");
              } else {
                notify(`Remark length can not exceed 2000 characters!`, "warning", false, false);
              }
            }}
            value={remark}
            margin="dense"
            id="remark"
            label="Remark"
            type="text"
            multiline
            minRows={3}
            fullWidth
            variant="standard"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleClickSubmit}>Replacement Pn Rejected</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
